var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('finance-invoices',{attrs:{"api-method":_vm.apiMethod,"is-master-account":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }